import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface ResendPartnerInvitationBody {
    partnerEmail: string;
    partnerStytchId: string;
}

export const useResendPartnerInvitation = requestBuilder.mutation<
    GeneralResponse,
    ResendPartnerInvitationBody,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/users/${id}/resend-partner-invite-email`,
    method: 'POST',
});
